export default () => ({
  crewRateList: [],
});
